import { ContentCopy } from '@mui/icons-material'
import { Button, Typography } from '@mui/material'
import { useAgencyInfo } from 'context/agency'
import React, { useState } from 'react'
import DoneIcon from '@mui/icons-material/Done';
import env from '../../../../../config/env';

const BespokeUrlPage = ({ formData }) => {
    const [agency] = useAgencyInfo();
    const [copied, setCopied] = useState(false);

    const handleCopyLink = () => {
        try {
            let link = `${agency?.domain !== undefined ? "https://" + agency?.domain : env.APP_URL}/integration-app/sign-up?id=${formData?.id}`

            const textArea = document.createElement("textarea");
            textArea.value = link;

            // Prevent scrolling/jumping
            textArea.style.position = "fixed";
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.opacity = "0";

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            const successful = document.execCommand("copy");
            if (successful) {
                setCopied(true);
                setTimeout(() => setCopied(false), 5000);
            } else {
                console.log("Copy failed.");
            }

            document.body.removeChild(textArea);
        } catch (err) {
            console.error("Copy failed:", err);
        }
    };

    return (
        <div>
            <Typography variant='paragraph' sx={{ fontSize: "14px", fontWeight: "bold" }}>
                Unique Sign-up link
            </Typography>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "8px" }}>
                <input
                    type="text"
                    placeholder="Your unique sign-up link"
                    style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "10px",
                        border: "1px solid #ccc",
                        fontSize: "16px",
                        outline: "none",
                    }}
                    value={Object.keys(formData)?.length > 0 ? `${agency?.domain !== undefined ? "https://" + agency?.domain : env.APP_URL}/integration-app/sign-up?id=${formData?.id}` : "loading..."}
                    disabled
                />
                <Button sx={{ border: "1px solid #ccc", paddingBlock: "11px" }} disabled={Object.keys(formData).length === 0} onClick={() => {
                    handleCopyLink()
                }}>
                    {copied ? <DoneIcon color='disabled' sx={{ color: "#009d05ff" }} /> : <ContentCopy sx={{ color: "#babec3" }} />}
                </Button>
            </div>
            <Typography variant='paragraph' sx={{ fontSize: "13px", fontWeight: "medium" }}>Share this unique link with authorized users for direct access to the integration page.</Typography>
        </div>
    )
}

export default BespokeUrlPage